import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWalletSelector } from '../utils/WalletSelectorContext';

const Home = ({ acc }) => {
  const { t, i18n } = useTranslation();

  const { modal } = useWalletSelector();

  const handleLogin = () => modal.show();

  return (
    <main
      className={
        i18n.language === 'en'
          ? 'my-10 max-w-screen-xl min-h-[65vh] text-center lg:py-10 flex flex-col md:flex-row-reverse gap-5'
          : 'my-10 max-w-screen-xl min-h-[65vh] text-center lg:py-10 flex flex-col md:flex-row gap-5'
      }>
      <section className='w-full flex items-center justify-center'>
        <img
          className={
            i18n.language === 'en'
              ? 'm-0 md:ml-8 md:-mr-5 w-full max-w-[350px] md:max-w-max'
              : 'm-0 md:mr-8 md:-ml-5 w-full max-w-[350px] md:max-w-max'
          }
          src='https://res.cloudinary.com/omar45/image/upload/v1668513606/NEAR/quizly_home.svg'
          alt='online quiz'
        />
      </section>
      <section
        className={
          i18n.language === 'en'
            ? 'w-full md:text-left text-center flex md:items-start items-center justify-center flex-col gap-8'
            : 'w-full md:text-left text-center flex md:items-end items-center justify-center flex-col gap-8'
        }>
        <h1 className='mt-12 md:mt-0 logo-font -ml-1 text-6xl leading-none text-primary-500 md:text-7xl lg:text-8xl'>
          Quizly
        </h1>
        <p
          className={
            i18n.language === 'en'
              ? 'md:mb-3 text-2xl font-semibold max-w-[18ch] text-gray-900 md:text-3xl lg:text-4xl dark:text-white'
              : 'md:mb-3 text-2xl font-semibold max-w-[18ch] text-gray-900 md:text-3xl lg:text-4xl dark:text-white text-right'
          }
          dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
          {t('landing-subtitle')}
        </p>
        <div>
          {acc.accountId ? (
            <Link
              to={'/profile'}
              className='w-fit mr-auto relative inline-flex items-center justify-center p-0.5 overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-primary-400 to-primary-600 group-hover:from-primary-400 group-hover:to-primary-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-primary-200 dark:focus:ring-primary-700'>
              <span
                className={
                  i18n.language === 'en'
                    ? 'relative px-5 py-3 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0 gap-2 flex items-center justify-end'
                    : 'relative px-5 py-3 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0 gap-2 flex flex-row-reverse items-center justify-end'
                }>
                {t('landing-button1')}
                {i18n.language === 'en' ? (
                  <svg
                    className='w-5 h-5'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M14 5l7 7m0 0l-7 7m7-7H3'></path>
                  </svg>
                ) : (
                  <svg
                    className='w-5 h-5'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M10 19l-7-7m0 0l7-7m-7 7h18'></path>
                  </svg>
                )}
              </span>
            </Link>
          ) : (
            <button
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              onClick={handleLogin}
              className='inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900'>
              {t('landing-login-button')} NEAR
            </button>
          )}
        </div>
        {/* <section className='grid md:grid-cols-3 gap-3'>
        <div className='relative aspect-6/5 flex items-center justify-center'>
        <span
        unselectable='on'
        className='absolute text-[21rem] -top-28 logo-font-stroke opacity-40'>
        C
        </span>
        <span className='font-bold text-5xl z-10 tracking-widest'>
        Create
        </span>
        </div>
        <div className='relative aspect-6/5 flex items-center justify-center'>
        <span className='absolute text-[21rem] -top-28 left-1 logo-font-stroke opacity-40'>
        S
        </span>
        <span className='font-bold text-5xl z-10 tracking-widest'>Solve</span>
        </div>
        <div className='relative aspect-6/5 flex items-center justify-center'>
        <span className='absolute text-[21rem] -top-28 logo-font-stroke opacity-40'>
        E
        </span>
        <span className='font-bold text-5xl z-10 tracking-widest'>Earn</span>
        </div>
      </section> */}
      </section>
    </main>
  );
};

export default Home;
